import axios from 'axios';

const lineService = {
  async getForwardingList(lineId) {
    return axios.get(`/lines/${lineId}/forwarding-list`);
  },
};

export default lineService;
